<template>
  <router-view/>
  <GlobalFooter :links="links" :copyright="copyright" style="margin-top: 24px;" />
</template>
<script>
    export default {
        data () {
            return {
                links: [
                    // {
                    //     key: '帮助',
                    //     title: '帮助',
                    //     href: 'https://www.iviewui.com',
                    //     blankTarget: true
                    // }<Icon type="" />,
                    // {
                    //     key: '海南文联',
                    //     icon: 'ios-link-outline',
                    //     href: 'https://github.com/view-design/ViewUIPlus',
                    //     blankTarget: true
                    // },
                    // {
                    //     key: '条款',
                    //     title: '条款',
                    //     href: '',
                    //     blankTarget: true
                    // }
                ],
                copyright: 'Copyright © 2023 海南文联'
            }
        }
    }
</script>

